import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.handleScroll = this.handleScroll.bind(this)

    // Écouteurs d'événements pour le scroll de la fenêtre
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.handleScroll)

    // Écouteurs pour les navigations Turbo
    document.addEventListener('turbo:load', this.handleScroll)
    document.addEventListener('turbo:render', this.handleScroll)

    // Écouteur spécifique pour le scroll de l'agenda
    this.scheduleScrollContainer = document.querySelector('.schedule-content-scroll')
    if (this.scheduleScrollContainer) {
      this.scheduleScrollContainer.addEventListener('scroll', this.handleScroll)
    }

    // Appel initial pour s'assurer du bon état
    this.handleScroll()
  }

  disconnect() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.handleScroll)
    document.removeEventListener('turbo:load', this.handleScroll)
    document.removeEventListener('turbo:render', this.handleScroll)

    // Nettoyage de l'écouteur pour l'agenda
    if (this.scheduleScrollContainer) {
      this.scheduleScrollContainer.removeEventListener('scroll', this.handleScroll)
    }
  }

  handleScroll() {
    // Détermine la position de scroll à partir de la fenêtre ou du container de l'agenda
    let scrollY = window.scrollY

    // Si on est sur la page agenda, utilise le scroll du container interne
    if (this.scheduleScrollContainer) {
      scrollY = Math.max(scrollY, this.scheduleScrollContainer.scrollTop)
    }

    // Masquage de la navbar sur toutes les tailles d'écran
    if (scrollY > 80) {
      this.element.classList.add('navbar--hidden')
    } else {
      this.element.classList.remove('navbar--hidden')
    }
  }
}
